// 301-style redirects from retired or commonly-searched alternative service
// slugs to their current equivalents. Consumed by every route that takes a
// `$service` param so old inbound links (search results, external backlinks,
// bookmarks) and keyword-set URLs don't 404.
export const SERVICE_SLUG_REDIRECTS: Record<string, string> = {
  "airbnb-turnaround": "airbnb-holiday-let",
  "gutter-clearance": "gutter-cleaning",
  "jet-washing": "driveway-patio",
  // "domestic cleaning" is the highest-volume verified term in the SS0–SS9
  // keyword set that had no destination; it is the same job as home cleaning.
  "domestic-cleaning": "home-cleaning",
  "deep-clean": "deep-cleaning",
};

export function redirectedServiceSlug(slug: string): string | null {
  return SERVICE_SLUG_REDIRECTS[slug] ?? null;
}

/**
 * Service-shaped slugs that have no area×service page but do have a dedicated
 * hub. Sent there in a single hop instead of 404ing.
 */
export const SERVICE_HUB_REDIRECTS: Record<string, string> = {
  "eco-friendly-cleaners": "/eco-friendly-cleaners-southend",
  "eco-friendly-cleaning": "/eco-friendly-cleaners-southend",
  "green-cleaning": "/eco-friendly-cleaners-southend",
};

export function serviceHubRedirect(slug: string): string | null {
  return SERVICE_HUB_REDIRECTS[slug] ?? null;
}
